import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import DialogActions from '@mui/material/DialogActions';
import { useAppSelector } from '../redux/store';
import { OpenModalContainer } from './openModalContainer';
import { RefreshButton } from './refreshButton';
export const ConnectionLostModalContainer = () => {
    const isConnectionLost = useAppSelector((state) => state.session.isConnectionLost);
    if (!isConnectionLost) {
        return null;
    }
    return (_jsx(OpenModalContainer, { title: 'Connection Lost', children: _jsx(DialogActions, { children: _jsx(RefreshButton, { type: 'labeled' }) }) }));
};
